// @ts-expect-error - TODO: add types
import convertBase64ToUrlSafeBase64 from './internal/base64/convertBase64ToUrlSafeBase64';
// @ts-expect-error - TODO: add types
import convertUuidToBase64 from './internal/base64/convertUuidToBase64';
// @ts-expect-error - TODO: add types
import isValidUuid from './internal/isValidUuid';
// @ts-expect-error - TODO: add types
import getLegacyUuidIdentifier from './internal/getLegacyUuidIdentifier';
// @ts-expect-error - TODO: add types
import getVersionAsSymbol from './internal/version/getVersionAsSymbol';
const getTokenParts = ({
  formId,
  portalId,
  version = 1
}) => {
  return {
    legacyPrefix: isValidUuid(formId) ? '' : getLegacyUuidIdentifier(),
    versionSymbol: getVersionAsSymbol(version),
    encodedFormId: convertBase64ToUrlSafeBase64(convertUuidToBase64(formId.replace(/[^a-fA-F0-9]/g, '')).substring(0, 22)),
    encodedPortalId: Number(portalId).toString(36)
  };
};
export default getTokenParts;